var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wgu-module-card',_vm._b({staticClass:"vue-table-win",style:({ left: _vm.tblLeft, width: _vm.tblWidth, top: '23vh' }),attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('vue-table',{staticClass:"table-container pa-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }